(function (angular) {
  angular
    .module('acme.view.application.programs.detail.dependents.controllers', [
      'acme.common.service.api',
      'acme.common.service.helpers',
      'acme.common.service.userPreferences',
    ])

    .controller('ProgramsDetailDependentsController', ProgramsDetailDependentsController);

  ProgramsDetailDependentsController.$inject = [
    '$scope',
    '$timeout',
    'ResolveViewData',
    'ResolveTemplatesData',
    'ResolveDependentsData',
    'ApiService',
    'HelpersService',
    'UserPreferencesService',
  ];

  function ProgramsDetailDependentsController(
    $scope,
    $timeout,
    ResolveViewData,
    ResolveTemplatesData,
    ResolveDependentsData,
    ApiService,
    HelpersService,
    UserPreferencesService
  ) {
    var updateTimer;

    $scope.programsDetailDependents = {
      isAdding: false,
      emptyImage: '/assets/img/global/empty-event-image.jpg',
      previewImage: '',

      model: {},
      program: {},

      search: {},
      savedSummaries: [],
      summaries: [],
      templates: [],

      currentDependent: {},

      strip: HelpersService.strip,

      dateFormat: '',

      init: function () {
        if (ResolveViewData.data && ResolveViewData.data.success) {
          this.success.init(ResolveViewData);
        } else {
          this.error.init(ResolveViewData);
        }

        if (ResolveDependentsData.data && ResolveDependentsData.data.success) {
          this.success.initDependents(ResolveDependentsData);
        } else {
          this.error.initDependents(ResolveDependentsData);
        }

        if (ResolveTemplatesData.data && ResolveTemplatesData.data.success) {
          this.success.initSummaries(ResolveTemplatesData);
        } else {
          this.error.initSummaries(ResolveTemplatesData);
        }

        $scope.$watch('$destroy', this.onDestroy);

        this.dateFormat = UserPreferencesService.getDateFormat('standardDate', 'dateFormat');
      },

      showTemplates: function () {
        this.isAdding = true;
      },

      hideTemplates: function () {
        this.isAdding = false;
      },

      toggleTemplates: function () {
        this.isAdding = !this.isAdding;
      },

      preview: function (template) {
        this.previewImage =
          template && template.primaryImage && template.primaryImage.preview ? template.primaryImage.preview : false;
      },

      getPrereqStub: function () {
        return {
          eventTemplateId: '',
          min: {
            days: 0,
            hours: 0,
            minutes: 1,
            endOfDay: false,
          },
          max: {
            days: 365,
            hours: 0,
            minutes: 0,
            endOfDay: false,
          },
        };
      },

      findSummary: function (id) {
        var i,
          ii,
          r = false;

        for (i = 0, ii = this.savedSummaries.length; i < ii; i++) {
          if (this.savedSummaries[i].id === id) {
            r = this.savedSummaries[i];
            break;
          }
        }

        return r;
      },

      addTemplate: function (id) {
        var i,
          ii,
          j,
          jj,
          merged = {};

        for (i = this.summaries.length - 1, ii = 0; i >= ii; i--) {
          if (this.summaries[i].id === id) {
            merged = this.summaries.splice(i, 1)[0];
            for (j = 0, jj = this.model.dependents.length; j < jj; j++) {
              if (this.model.dependents[j].eventTemplateId === id) {
                HelpersService.decorate(merged, this.model.dependents[j]);
                break;
              }
            }
            this.templates.push(merged);
          }
        }
      },

      stripExisting: function (templates) {
        var i,
          ii,
          j,
          jj,
          merged = {};

        for (i = templates.length - 1, ii = 0; i >= ii; i--) {
          if (templates[i].id === this.program.id) {
            templates.splice(i, 1);
            continue;
          }
          if (this.hasDependents()) {
            for (j = 0, jj = this.model.dependents.length; j < jj; j++) {
              if (templates[i].id === this.model.dependents[j].eventTemplateId) {
                // Load templates which already exist
                console.log('ProgramsDetailDependentsController::stripExisting', templates[i].id);
                merged = templates.splice(i, 1)[0];
                HelpersService.decorate(merged, this.model.dependents[j]);
                this.templates.push(merged);
                break;
              }
            }
          }
        }
        console.log('ProgramsDetailDependentsController::stripExisting', this.templates);

        return templates.reverse();
      },

      pruneTemplates: function () {
        var i,
          ii,
          j,
          jj,
          tmp = [];

        for (j = 0, jj = this.model.dependents.length; j < jj; j++) {
          for (i = 0, ii = this.templates.length; i < ii; i++) {
            if (this.templates[i].id === this.model.dependents[j].eventTemplateId) {
              tmp.push(this.templates[i]);
              break;
            }
          }
        }
        console.log('ProgramsDetailDependentsController::pruneTemplates', tmp);

        this.templates = tmp.slice(0);
      },

      hasDependents: function () {
        return this.model && this.model.dependents instanceof Array && this.model.dependents.length > 0;
      },

      /**
       * All dependents in our model must be locked before attempting any change
       * @param {{ids: Array<string>, promiseFn: Promise<any> }} props
       */
      wrapWithObjectLocks: function (props) {
        return ApiService.lock
          .createMany({ type: 'EventTemplate', ids: props.ids })
          .then(function () {
            return props.promiseFn();
          })
          .then(function (promiseFnResponse) {
            return ApiService.lock.removeMany({ type: 'EventTemplate', ids: props.ids }).then(function () {
              return promiseFnResponse;
            });
          });
      },

      add: function (id) {
        this.currentDependent = this.getPrereqStub();
        this.currentDependent.eventTemplateId = id;
        this.previewImage = false;

        if (!this.model) {
          this.model = {
            dependents: [this.currentDependent],
          };
          this.create();
        } else {
          this.model.dependents.push(this.currentDependent);
          this.update();
        }
        this.addTemplate(id);
      },

      create: function () {
        var self = $scope.programsDetailDependents;

        var dependentsEventTemplateIds = self.model.dependents.map(function (dependent) {
          return dependent.eventTemplateId;
        });

        return self.wrapWithObjectLocks({
          ids: dependentsEventTemplateIds,
          promise: function () {
            return ApiService.program.dependents
              .create(self.program.id, self.model)
              .then(self.success.create, self.error.create);
          },
        });
      },

      remove: function (id) {
        var self = $scope.programsDetailDependents;
        var i;
        var ii;
        var removed = {};

        console.log('ProgramsDetailDependentsController::update', self.model);

        var dependentsEventTemplateIds = self.model.dependents.map(function (dependent) {
          return dependent.eventTemplateId;
        });

        if (this.hasDependents()) {
          for (i = 0, ii = this.model.dependents.length; i < ii; i++) {
            console.log('ProgramsDetailDependentsController::remove', id === this.model.dependents[i].eventTemplateId);
            if (this.model.dependents[i].eventTemplateId === id) {
              console.log('ProgramsDetailDependentsController::remove', this.model.dependents[i].eventTemplateId);
              removed = this.model.dependents.splice(i, 1);
              this.summaries.push(this.findSummary(removed[0].eventTemplateId));
              break;
            }
          }

          console.log('ProgramsDetailDependentsController::remove', this.model.dependents);

          return self.wrapWithObjectLocks({
            ids: dependentsEventTemplateIds,
            /**
             * If we've removed the last dependent we must clear the entire object
             * Otherwise we can simply update
             */
            promiseFn: function () {
              if (self.hasDependents()) {
                return ApiService.program.dependents
                  .update(self.program.id, self.model)
                  .then(self.success.remove, self.error.remove);
              }

              return ApiService.program.dependents.remove(self.program.id).then(self.success.remove, self.error.remove);
            },
          });
        }
      },

      update: function () {
        var self = $scope.programsDetailDependents;
        console.log('ProgramsDetailDependentsController::update', self.model);

        var dependentsEventTemplateIds = self.model.dependents.map(function (dependent) {
          return dependent.eventTemplateId;
        });

        return self.wrapWithObjectLocks({
          ids: dependentsEventTemplateIds,
          promiseFn: function () {
            return ApiService.program.dependents
              .update(self.program.id, self.model)
              .then(self.success.update, self.error.update);
          },
        });
      },

      save: function () {
        var i, ii, j, jj;
        console.log('ProgramsDetailDependentsController::save', this.model);

        for (i = 0, ii = this.templates.length; i < ii; i++) {
          for (j = 0, jj = this.model.dependents.length; j < jj; j++) {
            if (this.templates[i].id === this.model.dependents[j].eventTemplateId) {
              this.model.dependents[j].max = this.templates[i].max;
              this.model.dependents[j].min = this.templates[i].min;
              break;
            }
          }
        }

        this.update();
      },

      success: {
        init: function (response) {
          console.log('ProgramsDetailDependentsController::success::init', response);
          if (!response.data.payload) {
            return;
          }
          $scope.programsDetailDependents.program = response.data.payload;
        },

        initSummaries: function (response) {
          console.log('ProgramsDetailDependentsController::success::initTemplates', response);
          if (!response.data.payload.list) {
            return;
          }
          $scope.programsDetailDependents.savedSummaries = response.data.payload.list.slice(0);
          $scope.programsDetailDependents.summaries = $scope.programsDetailDependents.stripExisting(
            response.data.payload.list
          );
        },

        initDependents: function (response) {
          console.log('ProgramsDetailDependentsController::success::initDependents', response);
          if (!response.data.payload) {
            return;
          }
          $scope.programsDetailDependents.model = response.data.payload;
        },

        create: function (response) {
          $scope.programsDetailDependents.hideTemplates();
          $scope.programsDetailDependents.addTemplate($scope.programsDetailDependents.currentDependent.eventTemplateId);
          $scope.programsDetailDependents.currentDependent = {};

          return response;
        },
        remove: function (response) {
          $scope.programsDetailDependents.pruneTemplates();
        },
        update: function (response) {
          $scope.programsDetailDependents.success.create(response);
        },
      },

      error: {
        init: function (response) {},
        initSummaries: function (response) {},
        initDependents: function (response) {},
        getTemplate: function (response) {},

        create: function (response) {
          return response;
        },
        remove: function (response) {},
        update: function (response) {},
      },

      onDestroy: function () {
        $timeout.cancel(updateTimer);
        $scope.programsDetailDependents.save();
      },

      onFieldBlur: function (e) {
        console.log('ProgramsDetailDependentsController::onTemplatesUpdate', e);

        if (updateTimer) {
          $timeout.cancel(updateTimer);
        }
        updateTimer = $timeout(function () {
          $scope.programsDetailDependents.save();
        }, 1000);
      },

      onDateFormatLoad: function () {
        $scope.programsDetailDependents.dateTimeFormat = UserPreferencesService.getDateTimeFormat('sortDateTime');
      },
    };

    $scope.programsDetailDependents.init();
  }
})(window.angular);
